<template>
  <div class="city-select">
    <el-cascader
      ref="select"
      size="mini"
      :props="props"
      :value="value"
      :options="regionList"
      :filterable="filterable"
      @change="change"
    ></el-cascader>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
export default {
  props: {
    value: [String, Array],
    filterable: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    ...mapState(['rawRegionList']),
    ...mapGetters(['regionList'])
  },
  data() {
    return {
      props: {
        label: 'regionName',
        value: 'com',
        multiple: true,
        checkStrictly: false
      }
    };
  },
  methods: {
    change(value) {
      this.$emit('input', value);
      //console.log('change', value);
    }
  },

  mounted() {
    this.$store.dispatch('getRegionList');
  }
};
</script>

<style lang="less" scoped>
.city-select {
  /deep/.el-cascader {
    width: 100%;
    .el-cascader__tags {
      .el-cascader__search-input {
        color: #fff;
      }
    }
  }
}
</style>
